import type { AnimationConfig } from '@game-platform/pack-animation';

// Every pack whose payload this session has seen: its own mechanic, or null
// when it plays the operator's global one.
const known = new Map<string, AnimationConfig | null>();
const listeners = new Set<(animation: AnimationConfig) => void>();

/** Filled from every pack detail and every order's embedded pack. */
export function rememberOfferAnimation(offerId: string | number, animation: AnimationConfig | null): void {
  known.set(String(offerId), animation);
  if (animation) for (const cb of listeners) cb(animation);
}

/** The pack's own mechanic, null when it has none, undefined when the pack has not been seen. */
export function knownOfferAnimation(offerId: string | number): AnimationConfig | null | undefined {
  return known.get(String(offerId));
}

export function knownOfferOverrides(): AnimationConfig[] {
  return [...known.values()].filter((animation): animation is AnimationConfig => animation !== null);
}

/** Hears every pack override as it arrives. */
export function onOfferOverride(cb: (animation: AnimationConfig) => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

export function forgetOfferAnimations(): void {
  known.clear();
}
